import * as get from 'lodash.get';
import { apiClientSelectors } from 'framework/selectors';
import { SITEADMIN_LOAD_USER } from './CommonPage.Constants';

export const getUser = (state) => get(state, 'siteadmin.user');

export const workInProgress = (state) => apiClientSelectors.getIsFetching(state, SITEADMIN_LOAD_USER)
&& !apiClientSelectors.getHasError(state, SITEADMIN_LOAD_USER);
